/**
 * THE-FIRST-BUILD-SCREEN-1 — "after signup with email verified, never before".
 *
 * AuthGuard asks whether somebody is signed in and what they may do, and has
 * never read `email_confirmed_at` (AUDITED in the record). The ruling puts the
 * first build behind verification, so the first build and the build it starts
 * stand behind this as well as behind the capability.
 *
 * It is deliberately narrow: it guards the two screens this lane owns rather
 * than changing what every route in the product means.
 */
import { Navigate } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from '../hooks/useAuth'
import { isVerified } from '../lib/firstBuildScreen'

export function VerifiedOnly({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth()
  if (loading) return null
  if (!user) return <Navigate to="/login" replace />
  // AUDITED: there is no screen that says "go and verify", so an unverified
  // person goes back to the door they came through, where the sentence they
  // typed is still carried and the confirmation link is still in their inbox.
  if (!isVerified(user as { email_confirmed_at?: unknown })) {
    return <Navigate to="/signup" replace />
  }
  return <>{children}</>
}
